import { render, staticRenderFns } from "./ImageManager.vue?vue&type=template&id=9c5d3884&scoped=true&"
import script from "./ImageManager.vue?vue&type=script&lang=js&"
export * from "./ImageManager.vue?vue&type=script&lang=js&"
import style0 from "./ImageManager.vue?vue&type=style&index=0&id=9c5d3884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5d3884",
  null
  
)

export default component.exports